import {Stack} from 'shells/layout/stack/stack';
import {LEVEL_COLORS} from 'shells/table/matrix-heatmap/consts';
import {Body} from 'shells/typography/body';

import type {ForecastCell} from './daily-performance-summary-modal';

import styles from './daily-performance-summary-modal.module.css';

interface Props {
    forecastCells: ForecastCell[];
}

export function AvailabilityForecast(props: Props) {
    const visibleCells = props.forecastCells.slice(0, 15);

    return (
        <Stack spacing={8}>
            <Stack
                isHorizontal={true}
                spacing={8}
                alignItems='center'
                justifyContent='space-between'
            >
                <Body size='large' color='dark' isBold={true}>
                    Availability forecast
                </Body>
                <div className='mt-2'>
                    <Body color='light'>Next 15 days</Body>
                </div>
            </Stack>
            <Stack spacing={4} isHorizontal={true}>
                {visibleCells.map((cell, i) => (
                    <div
                        key={i}
                        className={styles['forecast-cell']}
                        style={{backgroundColor: LEVEL_COLORS[cell.level]}}
                        data-tip={cell.date}
                        data-place='top'
                        data-effect='solid'
                    />
                ))}
            </Stack>
            <Stack
                isHorizontal={true}
                spacing={8}
                alignItems='center'
                justifyContent='space-between'
            >
                <Body color='light'>Day 0</Body>
                <Body color='light'>Day 15</Body>
            </Stack>
        </Stack>
    );
}
